// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!./theme.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../core/components/shared.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#page-wrapper {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  background-color: #f2f1f3;
}

@media (max-width: 48rem) {

#page-wrapper {
    flex-direction: column-reverse;
}
  }

#page-body {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;
}

header {
  background-color: var(--shell-bg-color);
  display: flex;
  flex: 0 0 3.5rem;
  box-shadow: var(--shadow);
  z-index: 5;
}

header h1 {
    margin: 1rem;
    color: var(--shell-color);
    font-size: 1.25rem;
    line-height: 1.5rem;
    flex-grow: 1;
  }
`, "",{"version":3,"sources":["webpack://./beach/components/AppShell.css"],"names":[],"mappings":"AAGA;EACE,uDAAuD;EACvD,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,yBAAyB;AAK3B;;AAHE;;AAVF;IAWI,8BAA8B;AAElC;EADE;;AAGF;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;AASZ;;AAPE;IACE,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;EACd","sourcesContent":["@import \"./theme.css\";\r\n@import \"../../core/components/shared.css\";\r\n\r\n#page-wrapper {\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n  position: fixed;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  display: flex;\r\n  background-color: #f2f1f3;\r\n\r\n  @media (max-width: 48rem) {\r\n    flex-direction: column-reverse;\r\n  }\r\n}\r\n\r\n#page-body {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex-grow: 1;\r\n  overflow: auto;\r\n}\r\n\r\nheader {\r\n  background-color: var(--shell-bg-color);\r\n  display: flex;\r\n  flex: 0 0 3.5rem;\r\n  box-shadow: var(--shadow);\r\n  z-index: 5;\r\n\r\n  & h1 {\r\n    margin: 1rem;\r\n    color: var(--shell-color);\r\n    font-size: 1.25rem;\r\n    line-height: 1.5rem;\r\n    flex-grow: 1;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
